import React, {
    Fragment,
    useEffect
} from 'react';

import {
    useDispatch
} from 'react-redux';

import HeaderUno from '../Compartidos/HeaderUno';
import HeaderMetodos from '../../AuxiliaresPaginas/HeaderMetodos';

import useConfigAuth from '../../../Hooks/useConfigAuth';

import {
    solicitoListaEjerciciosAction
} from '../../../actions/solicitoInformacionEjercicioActions';


// css

import {
    MenuInferencia,
    BotonesInferencia,
    BotonMenuInferencia
} from '../../Css/StyledInferencia';

import {
    HrMetodos
} from '../../Css/StyledHeader';


const Inferencia = () => {


    const dispatch =
        useDispatch();


    const [config] =
        useConfigAuth();


    // =========================================================
    // CARGAR LISTAS
    // =========================================================

    useEffect(() => {


        const informacion = {

            config,

            payload: {

            }

        };


        dispatch(
            solicitoListaEjerciciosAction(
                informacion
            )
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    return (

        <Fragment>


            <HeaderUno />


            <HrMetodos
                margin='0 0.2rem 0.5rem 0.2rem'
            />


            <HeaderMetodos

                l1={"metodos/"}

                l2={"lenguaje/"}

                n1={"Métodos"}

                n2={"LENGUAJE"}

                componente={"INFERENCIA"}

                paciente={true}

                bgcolor="#FF9D2E"

                color="white"

                width='96vw'

                shadow="0px 4px 4px rgba(0, 0, 0, 0.25)"

                display="none"

            />


            <MenuInferencia>


                <BotonesInferencia>


                    {/* ================================================= */}
                    {/* LEN38                                             */}
                    {/* ================================================= */}

                    <BotonMenuInferencia
                        to="/escritorio/metodos/lenguaje/inferencia/LEN38"
                    >

                        <img
                            src="/img/portadas/LEN38.png"
                            alt=""
                        />

                        <span>
                            Infiere la situación
                        </span>

                    </BotonMenuInferencia>


                    {/* ================================================= */}
                    {/* LEN39                                             */}
                    {/* ================================================= */}

                    <BotonMenuInferencia
                        to="/escritorio/metodos/lenguaje/inferencia/LEN39"
                    >

                        <img
                            src="/img/portadas/LEN39.png"
                            alt=""
                        />

                        <span>
                            Inferencias
                        </span>

                    </BotonMenuInferencia>


                    {/* ================================================= */}
                    {/* LEN40                                             */}
                    {/* ================================================= */}

                    <BotonMenuInferencia
                        to="/escritorio/metodos/lenguaje/inferencia/LEN40"
                    >

                        <img
                            src="/img/portadas/LEN40.png"
                            alt=""
                        />

                        <span>
                            Inferencias con opciones
                        </span>

                    </BotonMenuInferencia>


                    {/* ================================================= */}
                    {/* LEN41                                             */}
                    {/* ================================================= */}
                    {/*
                        LEN41 muestra su portada acá.

                        Después de entrar seguimos yendo
                        al selector de NIVEL 1, 2, 3 y 4.
                    */}

                    <BotonMenuInferencia
                        to="/escritorio/metodos/lenguaje/inferencia/LEN41-niveles"
                    >

                        <img
                            src="/img/portadas/LEN41.png"
                            alt=""
                        />

                        <span>
                            Inferencias de texto
                        </span>

                    </BotonMenuInferencia>


                </BotonesInferencia>


            </MenuInferencia>


        </Fragment>
    );
};


export default Inferencia;